import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './23-masters-examples2.mp3';

const transcript = `
  Wacht, ik heb er meer.
`;

const images = [
  'https://cdn.midjourney.com/1ac5c0f7-de5f-4089-91a2-bb8e10c4a4e4/0_1.png',
  'https://cdn.midjourney.com/1ac5c0f7-de5f-4089-91a2-bb8e10c4a4e4/0_3.png',
  'https://cdn.midjourney.com/290efca8-a52f-4f30-bb5d-beffdb4b5bf4/0_0.png',
  'https://cdn.midjourney.com/edefa7b8-7b1c-45b5-9dac-bfb510e763ce/0_0.png',
  'https://cdn.midjourney.com/fc5c74a6-c810-4529-beb7-10b96317c06f/0_3.png',
  'https://cdn.midjourney.com/343f2f52-2f23-46d3-9b81-02f297b907ab/0_1.png',
  'https://cdn.midjourney.com/343f2f52-2f23-46d3-9b81-02f297b907ab/0_3.png',
  'https://cdn.midjourney.com/a56f2aae-f693-4d64-940a-98584d79dad2/0_0.png',
  'https://cdn.midjourney.com/edefa7b8-7b1c-45b5-9dac-bfb510e763ce/0_1.png',
  'https://cdn.midjourney.com/48126a0c-e4ee-413a-8bbd-b631d45fad0b/0_0.png',
];

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} transition="fade" visualizer="hidden">
      <div className="flex items-center justify-center h-full">
        <div className="grid grid-cols-5 gap-2 h-[90vh] w-[95vw]">
          {images.map((image, index) => (
            <WebContent
              key={image}
              animation={{
                type: 'slide-up',
                delay: index * 100,
                duration: 800,
              }}
            >
              <div
                className={`
                  h-full w-full 
                  bg-black/50 
                  rounded-xl 
                  overflow-hidden 
                  transform 
                  hover:scale-105 
                  transition-transform
                `}
              >
                <img
                  src={image}
                  alt={`Synthography ${index + 1}`}
                  className="h-full w-full object-cover"
                />
              </div>
            </WebContent>
          ))}
        </div>
      </div>
    </Slide>
  );
};
